"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getVehicleQuery = void 0;
const types_1 = require("../types");
const getVehicleQuery = (resultFields = types_1.vehicleFields) => `
  query vehicleQuery($input: VehicleQueryInput) {
    vehicleQuery(input: $input) {
      pagination {
        ${types_1.paginationFields}
      }
      filters {
        ${types_1.vehicleQueryFilterFields}
      }
      results {
        ${resultFields}
      }
    }
  }
`;
exports.getVehicleQuery = getVehicleQuery;
//# sourceMappingURL=vehicle.js.map